// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportHeader } from './IReportHeader';
import {
    IReportHeaderFromJSON,
    IReportHeaderFromJSONTyped,
    IReportHeaderToJSON,
    IReportHeaderToJSONTyped,
} from './IReportHeader';
import type { IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto } from './IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto';
import {
    IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoFromJSON,
    IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoFromJSONTyped,
    IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoToJSON,
    IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto
 */
export interface IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {Array<IReportHeader>}
     * @memberof IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto
     */
    headers?: Array<IReportHeader>;
    /**
     * 
     * @type {Date}
     * @memberof IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto
     */
    last_updated_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto
     */
    date_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto
     */
    date_to?: Date;
    /**
     * 
     * @type {Array<IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto>}
     * @memberof IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto
     */
    content?: Array<IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto>;
    /**
     * 
     * @type {number}
     * @memberof IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto
     */
    total_records?: number;
    /**
     * 
     * @type {number}
     * @memberof IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto
     */
    page_number?: number;
    /**
     * 
     * @type {number}
     * @memberof IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto
     */
    page_size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto
     */
    has_next?: boolean;
}

/**
 * Check if a given object implements the IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto(value: object): value is IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto {
    return IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'headers': json['headers'] == null ? undefined : ((json['headers'] as Array<any>).map(IReportHeaderFromJSON)),
        'last_updated_at': json['last_updated_at'] == null ? undefined : (new Date(json['last_updated_at'])),
        'date_from': json['date_from'] == null ? undefined : (new Date(json['date_from'])),
        'date_to': json['date_to'] == null ? undefined : (new Date(json['date_to'])),
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoFromJSON)),
        'total_records': json['total_records'] == null ? undefined : json['total_records'],
        'page_number': json['page_number'] == null ? undefined : json['page_number'],
        'page_size': json['page_size'] == null ? undefined : json['page_size'],
        'has_next': json['has_next'] == null ? undefined : json['has_next'],
    };
}

export function IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDtoToJSON(json: any): IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto {
    return IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headers': value['headers'] == null ? undefined : ((value['headers'] as Array<any>).map(IReportHeaderToJSON)),
        'last_updated_at': value['last_updated_at'] == null ? undefined : ((value['last_updated_at']).toISOString()),
        'date_from': value['date_from'] == null ? undefined : ((value['date_from']).toISOString().substring(0,10)),
        'date_to': value['date_to'] == null ? undefined : ((value['date_to']).toISOString().substring(0,10)),
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoToJSON)),
        'total_records': value['total_records'],
        'page_number': value['page_number'],
        'page_size': value['page_size'],
        'has_next': value['has_next'],
    };
}

